<template>
    <servicos
        :permitirAprovar="false"
        :permitirReprovar="false"
        :permiteDetalhar="$temAcessoView('GESCON-FORN-SERV-00')"
        rotaDetalhar="Fornecedor_Contratos_Servicos_Detalhar"
        rotaListagem="Fornecedor_Contratos_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../gescon/aprovadores/Comprometimentos'

export default {
    name: 'FornecedorServicos',
    
    components: {
        Servicos
    },

    data() {
        return {}
    },

    computed: {
        fornecedorId() {
            return this.$store.getters.fornecedor?.fornecedorId || null
        },

        servicosServicos() {
            return {
                obterComprometimentos: () => {
                    return ServicosServicos.obterComprometimentos(this.fornecedorId)
                },
                obterComprometimentosPorVencimentos: () => {
                    return ServicosServicos.obterComprometimentosPorVencimentos(this.fornecedorId)
                },
                // Manter os outros métodos inalterados
                obterComprometimentoAnexos: ServicosServicos.obterComprometimentoAnexos,
                obterComprometimentoAnexosTipos: ServicosServicos.obterComprometimentoAnexosTipos,
                obterComprometimentoPorId: ServicosServicos.obterComprometimentoPorId,
                inserirComprometimentoAnexo: ServicosServicos.inserirComprometimentoAnexo,
                excluirComprometimentoAnexo: ServicosServicos.excluirComprometimentoAnexo,
                obterComprometimentoAnexo: ServicosServicos.obterComprometimentoAnexo,
                buscarFornecedores: ServicosServicos.buscarFornecedores,
                obterFiltros: ServicosServicos.obterFiltros
            }
        }
    },

    methods: {
        // Métodos auxiliares se necessário
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>